import { observer } from "mobx-react-lite";
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

import LoadingComponent from '../../app/layout/LoadingComponent';

import "./src/css/docentes.css"

import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';

import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { BsFillPersonFill } from "@react-icons/all-files/bs/BsFillPersonFill";
import { FaPhoneAlt } from "@react-icons/all-files/fa/FaPhoneAlt";
import { ImLocation } from "@react-icons/all-files/im/ImLocation";
import { BsSearch } from "@react-icons/all-files/bs/BsSearch";

import { RegionalBannerCentral } from "../Portafolio/Handlers/RegionalBannerCentral";
import Footer from '../Footer';
import { UsePDFMaker } from './handlers/UsePdfMaker';

import { useStore } from "../../app/stores/store";

const apiURL = process.env.REACT_APP_API_URL;

export default observer(function ReporteInscritosEd() {


    const { CCTOperacionStore, CATCursosStore, SGPersonaStore, userStore: { isLoggedIn, user }, modalStore } = useStore();
    const { loadCATCursos, getCATCursosRegistryAll } = CATCursosStore;
    
    // const url = apiURL + `/Courses/ReportGrades?CourseId=86`;
    // const urlPDF = apiURL + `/Courses/ReportGradesPDF?CourseId=86`;
    
    var pathGUID = window.location.pathname.split('/')[4];
    const url = apiURL + `/Courses/ReportGrades?CourseId=${encodeURI(pathGUID)}`;
    const urlPDF = apiURL + `/Courses/ReportGradesPDF?CourseId=${encodeURI(pathGUID)}`;
    const urlCOU = apiURL + `/Courses/${encodeURI(pathGUID)}`;
    
    const componentRef = useRef<HTMLDivElement>(null)

    const [student, setStudents] = useState([]);
    useEffect(() => { listaStudents() }, []);
    
    const listaStudents = async () => {
        
        const respoStudents = await axios(url);
        const { data } = respoStudents;
        
        const Estudents = data?.map((dataR: { fullName: string, dpi: number, courseId: number,  grade: number }) => {

            return {

                fullName: dataR.fullName,
                dpi: dataR.dpi,
                courseId: dataR.courseId,
                grade: dataR.grade

            }
        })

        setStudents(Estudents);
    }

    const [curso, setCursos] = useState([]);
    useEffect(() => { listaCurso() }, []);
    
    const listaCurso = async () => {
        
        const respoEdicion = await axios(url);
        const { data } = respoEdicion;
        
        const Curso = data?.map((dataR: { id: number, nombre: string }) => {

            return {

                id: dataR.id,
                nombre: dataR.nombre

            }
        })

        setCursos(Curso);
    }

    const StudentsList = (dataR: { fullName: string, dpi: number, courseId: number,  grade: number }) => {

        return (

            <li>
                <Container className="doc-reportes-listado-item">
                    <div className="convenio-body-section docr-sect1">{dataR.courseId}</div>
                    <div className="convenio-body-section docr-sect2">{dataR.fullName}</div>
                    <div className="convenio-body-section docr-sect3">{dataR.dpi}</div>
                    <div className="convenio-body-section docr-sect4">{dataR.grade >= 60 ? <p className="grade-green">{dataR.grade + " pts"}</p> : <p className="grade-red">{dataR.grade + " pts"}</p>  }</div>
                </Container>
            </li>

        )
    }

    return (

        <>

            <RegionalBannerCentral/>

            <Container className="lista-docentes-header lista-reportes-pages">
                <Col xs="12" sm="8" className="info-box">
                    <h1>Informe de avance de portafolio</h1>
                    <p>En esta pantalla encontrarás el resumen del informe relacionado al curso y edición consultada.</p>
                    <p>Si tienes algun inconveniente, por favor, comunicate con nuestro departamento de RRHH.</p>
                </Col>
            </Container>

            <Row>
                <Container className="reportes-head-resume">
                    <div className="resumen_top col-sm-12 shadow-sm">
                        <div className="row">
                            <div className='col-sm-6 col-md-3 resumen_item resumen_item1'><p>Modalidad<span>{"MOOC"}</span></p></div>
                            <div className='col-sm-6 col-md-3 resumen_item resumen_item2'><p>Inicio de inscripciones<span>{}</span></p><br /><p>Cierre de inscripciones<span>{}</span></p></div>
                            <div className='col-sm-6 col-md-3 resumen_item resumen_item3'><p>Inicio del curso<span>{}</span></p></div>
                            <div className='col-sm-6 col-md-3 resumen_item resumen_item4'><p>Inversión<span>{}</span></p></div>
                        </div>
                    </div>
                </Container>
            </Row>

            <Row>
                <Container className="convenio-head-list doc-reportes-listado">
                    <div className="convenio-head-section docr-sect1">No.</div>
                    <div className="convenio-head-section docr-sect2">Nombre de estudiante</div>
                    <div className="convenio-head-section docr-sect3">DPI</div>
                    <div className="convenio-head-section docr-sect4">Zona acumulada</div>
                </Container>
            </Row>

            <Row>
                <Col>
                    <Container className="convenio-body-list report-students-list-item">

                        <ul>

                            {
                                student?.map((students: { fullName: string, dpi: number, courseId: number,  grade: number }) => (
                                    <StudentsList {...students} />
                                ))
                            }

                        </ul>
                    
                    </Container>
                </Col>
            </Row>

            <Row className="impression-report-area">
                <Col>
                    <Container>           
                            
                        <a type="button" className="btn-primary" download={"Docente-Edicion.pdf"} href={UsePDFMaker(urlPDF)}> Descargar reporte en PDF</a>
          
                    </Container>        
                </Col>
            </Row>

            <Footer/>

        </>

    );
});